const cookiePrefix = "xi_website_";

export enum CookieName {
  AnonDistinctId = "anon_distinct_id",
  BootstrapData = "bootstrap_data",
  CCPAOptOut = "ccpa_opt_out",
  GeoCountry = "geo_country",
  PendingExposures = "pending_exposures",
  User = "user",
}

export const getCookieKey = (name: CookieName) => {
  if (name == CookieName.AnonDistinctId) {
    return CookieName.AnonDistinctId; // for compatibility with the main repo
  }
  return `${cookiePrefix}${name}`;
};
